import React, { useContext } from 'react';
import { AppContext } from '../context/AppContext';
import { MANUFACTURERS, getBrandStyle } from '../utils/catalog';

const ManufacturerGrid = ({ activeMfg, onSelectMfg, manufacturers }) => {
  const { showToast } = useContext(AppContext);
  const items = (manufacturers && manufacturers.length > 0) ? manufacturers : MANUFACTURERS;
  const [imgErrors, setImgErrors] = React.useState({});

  const handleImgError = (mfgId) => {
    setImgErrors((prev) => ({ ...prev, [mfgId]: true }));
  };

  return (
    <section className="page-section">
      <h2>
        <i className="fas fa-industry" /> All Manufacturers
      </h2>
      <div className="manufacturer-grid" role="list">
        {items.map((m) => {
          const brand = getBrandStyle(m.id);
          const hasError = imgErrors[m.id];

          return (
            <button
              key={m.id}
              type="button"
              className={`manufacturer-card ${activeMfg === m.id ? 'active' : ''}`}
              data-mfg={m.id}
              role="listitem"
              onClick={() => {
                onSelectMfg(m.id);
                showToast(`${m.label} models`);
              }}
            >
              {m.logo_url && !hasError ? (
                <span className="brand-avatar logo-img-container">
                  <img
                    src={m.logo_url}
                    alt={`${m.label} logo`}
                    className="brand-logo-img"
                    onError={() => handleImgError(m.id)}
                  />
                </span>
              ) : (
                <span className="brand-avatar" style={{ background: brand.color }}>
                  {brand.initial}
                </span>
              )}
              <span>{m.label}</span>
              <small>{m.hint}</small>
            </button>
          );
        })}
      </div>
    </section>
  );
};

export default ManufacturerGrid;
